/*
 *
 * DashBoardPage reducer
 *
 */

import { fromJS } from 'immutable';

export const initialState = fromJS({});

function dashBoardPageReducer(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}

export default dashBoardPageReducer;
